/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Name_Reverse_One_FrameInputs */



/**
* | output |
* | --- |
* | "Reverse 1 Frame" |
*
* @param {Shortcut_Keys_Name_Reverse_One_FrameInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_name_reverse_one_frame = /** @type {((inputs?: Shortcut_Keys_Name_Reverse_One_FrameInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Name_Reverse_One_FrameInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Reculer de 1 image")
	if (locale === "de") return /** @type {LocalizedString} */ ("Rückwärts 1 Bild")
	if (locale === "it") return /** @type {LocalizedString} */ ("Inverti 1 fotogramma")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Обратная сторона 1 кадр")
	if (locale === "es") return /** @type {LocalizedString} */ ("1 fotograma inverso")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("反转 1 帧")
	if (locale === "ja") return /** @type {LocalizedString} */ ("1フレーム逆")
	if (locale === "hi") return /** @type {LocalizedString} */ ("रिवर्स 1 फ्रेम")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Quadro Inverso 1")
	return /** @type {LocalizedString} */ ("Reverse 1 Frame")
});